(function () {
    'use strict';

    angular
        .module('app.application')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'application.overview',
                config: {
                    url: '/:ApplicationID/overview',
                    params: {
                         ApplicationID: {
                             value: '0'
                         }
                     },
                    templateUrl: 'app/application/overview/application.overview.html',
                    controller: 'ApplicationOverviewController',
                    controllerAs: 'vm',
                    title: 'Application Overview',
                    ncyBreadcrumb: {
                        parent: 'application.dashboard',
                        label: '{{vm.title}}'
                    },
                    settings: {
                        isVisible: false,
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Application Overview'
                    }
                }
            }
        ];
    }
})();
